// extracted by mini-css-extract-plugin
export default {"LicenseData":"LicenseData_LicenseData__jTG-9","containerWithPadding":"LicenseData_containerWithPadding__smmlf"};